import { render, staticRenderFns } from "./PxCamposCompraItemTableM365BuscheLepper.vue?vue&type=template&id=3b0772ab&"
import script from "./PxCamposCompraItemTableM365BuscheLepper.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableM365BuscheLepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports